'use strict';
// https://github.com/tc39/proposal-string-pad-start-end
var $export = require('./_export')
  , $pad    = require('./_string-pad');

$export($export.P, 'String', {
  padStart: function padStart(maxLength /*, fillString = ' ' */){
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


//////////////////
// WEBPACK FOOTER
// /var/www/umem/~/core-js/modules/es7.string.pad-start.js
// module id = 252
// module chunks = 0